import { render, staticRenderFns } from "./NavContent.vue?vue&type=template&id=940b84c2&scoped=true"
import script from "./NavContent.vue?vue&type=script&lang=js"
export * from "./NavContent.vue?vue&type=script&lang=js"
import style0 from "./NavContent.vue?vue&type=style&index=0&id=940b84c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940b84c2",
  null
  
)

export default component.exports